// extracted by mini-css-extract-plugin
export default {"error":"AuthContext_error__CSXDr"};